/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as HostRouteImport } from './routes/host'
import { Route as ASlugRouteImport } from './routes/a.$slug'
import { Route as HostIndexRouteImport } from './routes/host/index'
import { Route as ASlugCameraRouteImport } from './routes/a_.$slug.camera'
import { Route as ASlugGalleryRouteImport } from './routes/a_.$slug.gallery'
import { Route as HostAlbumsNewRouteImport } from './routes/host/albums/new'
import { Route as HostAlbumsIdIndexRouteImport } from './routes/host/albums/$id/index'
import { Route as HostAlbumsIdPayRouteImport } from './routes/host/albums/$id/pay'
import { Route as HostAlbumsIdSettingsRouteImport } from './routes/host/albums/$id/settings'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const HostRoute = HostRouteImport.update({
  id: '/host',
  path: '/host',
  getParentRoute: () => rootRouteImport,
} as any)
const ASlugRoute = ASlugRouteImport.update({
  id: '/a/$slug',
  path: '/a/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const HostIndexRoute = HostIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HostRoute,
} as any)
const ASlugCameraRoute = ASlugCameraRouteImport.update({
  id: '/a_/$slug/camera',
  path: '/a/$slug/camera',
  getParentRoute: () => rootRouteImport,
} as any)
const ASlugGalleryRoute = ASlugGalleryRouteImport.update({
  id: '/a_/$slug/gallery',
  path: '/a/$slug/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const HostAlbumsNewRoute = HostAlbumsNewRouteImport.update({
  id: '/albums/new',
  path: '/albums/new',
  getParentRoute: () => HostRoute,
} as any)
const HostAlbumsIdIndexRoute = HostAlbumsIdIndexRouteImport.update({
  id: '/albums/$id/',
  path: '/albums/$id/',
  getParentRoute: () => HostRoute,
} as any)
const HostAlbumsIdPayRoute = HostAlbumsIdPayRouteImport.update({
  id: '/albums/$id/pay',
  path: '/albums/$id/pay',
  getParentRoute: () => HostRoute,
} as any)
const HostAlbumsIdSettingsRoute = HostAlbumsIdSettingsRouteImport.update({
  id: '/albums/$id/settings',
  path: '/albums/$id/settings',
  getParentRoute: () => HostRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/host': typeof HostRouteWithChildren
  '/a/$slug': typeof ASlugRoute
  '/host/': typeof HostIndexRoute
  '/a/$slug/camera': typeof ASlugCameraRoute
  '/a/$slug/gallery': typeof ASlugGalleryRoute
  '/host/albums/new': typeof HostAlbumsNewRoute
  '/host/albums/$id/pay': typeof HostAlbumsIdPayRoute
  '/host/albums/$id/settings': typeof HostAlbumsIdSettingsRoute
  '/host/albums/$id/': typeof HostAlbumsIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/a/$slug': typeof ASlugRoute
  '/host': typeof HostIndexRoute
  '/a/$slug/camera': typeof ASlugCameraRoute
  '/a/$slug/gallery': typeof ASlugGalleryRoute
  '/host/albums/new': typeof HostAlbumsNewRoute
  '/host/albums/$id/pay': typeof HostAlbumsIdPayRoute
  '/host/albums/$id/settings': typeof HostAlbumsIdSettingsRoute
  '/host/albums/$id': typeof HostAlbumsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/host': typeof HostRouteWithChildren
  '/a/$slug': typeof ASlugRoute
  '/host/': typeof HostIndexRoute
  '/a_/$slug/camera': typeof ASlugCameraRoute
  '/a_/$slug/gallery': typeof ASlugGalleryRoute
  '/host/albums/new': typeof HostAlbumsNewRoute
  '/host/albums/$id/pay': typeof HostAlbumsIdPayRoute
  '/host/albums/$id/settings': typeof HostAlbumsIdSettingsRoute
  '/host/albums/$id/': typeof HostAlbumsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/host'
    | '/a/$slug'
    | '/host/'
    | '/a/$slug/camera'
    | '/a/$slug/gallery'
    | '/host/albums/new'
    | '/host/albums/$id/pay'
    | '/host/albums/$id/settings'
    | '/host/albums/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/a/$slug'
    | '/host'
    | '/a/$slug/camera'
    | '/a/$slug/gallery'
    | '/host/albums/new'
    | '/host/albums/$id/pay'
    | '/host/albums/$id/settings'
    | '/host/albums/$id'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/host'
    | '/a/$slug'
    | '/host/'
    | '/a_/$slug/camera'
    | '/a_/$slug/gallery'
    | '/host/albums/new'
    | '/host/albums/$id/pay'
    | '/host/albums/$id/settings'
    | '/host/albums/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  HostRoute: typeof HostRouteWithChildren
  ASlugRoute: typeof ASlugRoute
  ASlugCameraRoute: typeof ASlugCameraRoute
  ASlugGalleryRoute: typeof ASlugGalleryRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/host': {
      id: '/host'
      path: '/host'
      fullPath: '/host'
      preLoaderRoute: typeof HostRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a/$slug': {
      id: '/a/$slug'
      path: '/a/$slug'
      fullPath: '/a/$slug'
      preLoaderRoute: typeof ASlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/host/': {
      id: '/host/'
      path: '/'
      fullPath: '/host/'
      preLoaderRoute: typeof HostIndexRouteImport
      parentRoute: typeof HostRoute
    }
    '/a_/$slug/camera': {
      id: '/a_/$slug/camera'
      path: '/a/$slug/camera'
      fullPath: '/a/$slug/camera'
      preLoaderRoute: typeof ASlugCameraRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a_/$slug/gallery': {
      id: '/a_/$slug/gallery'
      path: '/a/$slug/gallery'
      fullPath: '/a/$slug/gallery'
      preLoaderRoute: typeof ASlugGalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/host/albums/new': {
      id: '/host/albums/new'
      path: '/albums/new'
      fullPath: '/host/albums/new'
      preLoaderRoute: typeof HostAlbumsNewRouteImport
      parentRoute: typeof HostRoute
    }
    '/host/albums/$id/': {
      id: '/host/albums/$id/'
      path: '/albums/$id'
      fullPath: '/host/albums/$id/'
      preLoaderRoute: typeof HostAlbumsIdIndexRouteImport
      parentRoute: typeof HostRoute
    }
    '/host/albums/$id/pay': {
      id: '/host/albums/$id/pay'
      path: '/albums/$id/pay'
      fullPath: '/host/albums/$id/pay'
      preLoaderRoute: typeof HostAlbumsIdPayRouteImport
      parentRoute: typeof HostRoute
    }
    '/host/albums/$id/settings': {
      id: '/host/albums/$id/settings'
      path: '/albums/$id/settings'
      fullPath: '/host/albums/$id/settings'
      preLoaderRoute: typeof HostAlbumsIdSettingsRouteImport
      parentRoute: typeof HostRoute
    }
  }
}

interface HostRouteChildren {
  HostIndexRoute: typeof HostIndexRoute
  HostAlbumsNewRoute: typeof HostAlbumsNewRoute
  HostAlbumsIdPayRoute: typeof HostAlbumsIdPayRoute
  HostAlbumsIdSettingsRoute: typeof HostAlbumsIdSettingsRoute
  HostAlbumsIdIndexRoute: typeof HostAlbumsIdIndexRoute
}

const HostRouteChildren: HostRouteChildren = {
  HostIndexRoute: HostIndexRoute,
  HostAlbumsNewRoute: HostAlbumsNewRoute,
  HostAlbumsIdPayRoute: HostAlbumsIdPayRoute,
  HostAlbumsIdSettingsRoute: HostAlbumsIdSettingsRoute,
  HostAlbumsIdIndexRoute: HostAlbumsIdIndexRoute,
}

const HostRouteWithChildren = HostRoute._addFileChildren(HostRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  HostRoute: HostRouteWithChildren,
  ASlugRoute: ASlugRoute,
  ASlugCameraRoute: ASlugCameraRoute,
  ASlugGalleryRoute: ASlugGalleryRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
